import { action, observable } from "mobx";
import { api } from "../../api";
import {
  IEmpresa,
  ILogPgdas,
  IReceitaBruta,
  ITransmissao,
} from "../../model";
import { toast } from "react-toastify";
import { nameFile } from "../../utils";

export class _PgdasStore {
  obs = observable({
    filtro: [] as ITransmissao[],
    loading: false as boolean,
    req: [] as ILogPgdas[],
    viewArquivos: false,
    viewDetalhes: false,
    currentPage: 1 as number,
    pgdas_length: 1 as number,
    gerando_extrato: false as boolean,
    transmitindo: false as boolean,
    loadingViewArquivo: false as boolean,
    tasks_length: 0 as number,
    loading_arquivos: false as boolean,
    transmitirPgdas: false as boolean,
    gerando_das: false as boolean,

    receita_bruta: [] as IReceitaBruta[],
    total_de_impostos: [] as IReceitaBruta[],
    receita_e_limite_atual: [] as IReceitaBruta[],
    segregacao_dos_tributos_periodo: [] as IReceitaBruta[],
    segregacao_dos_tributos: [] as IReceitaBruta[],
    segregacao_da_receita_bruta: [] as IReceitaBruta[],
    comparacao_entre_receitas: [] as IReceitaBruta[],
    projecao_linear_da_receita: [] as IReceitaBruta[],
    simples_nacional_periodo: [] as IReceitaBruta[],
    carga_tributaria: [] as IReceitaBruta[],
    segregacao_de_cargas: [] as IReceitaBruta[],
    simples_nacional: 0 as number,
    competencia: 0 as number,
    total_receita_bruta: 0 as number,
    total_receita_bruta_anterior: 0 as number,
    total_receita_bruta_12: 0 as number,
    limite_receita_simples: 0 as number,
    sublimite_receita: 0 as number,
    loading_bi: false as boolean,
    isBI: false as boolean,

  })


  @action
  async handleExtrato(empresa: IEmpresa, competencia: string, ano: string, valor_adicional: any): Promise<void> {
    this.obs.gerando_extrato = true

    let paramns = { empresa: empresa.cnpj, competencia: competencia, ano: ano, valor_adicional: valor_adicional == "." ? "0.0" : valor_adicional };

    try {
      let resp = await api.post(`/api/extrato`, paramns);

      if (resp.data.error && resp.data.error != "") {
        toast.error(resp.data.error, {});

      } else if (resp.data.ok === undefined) {
        toast.error('Não há informações para serem exibidas.', {});

      } else {
        const linkSource = `data:application/pdf;base64,${resp.data.ok}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = nameFile(empresa, "PGDAS-EXTRATO");
        downloadLink.click();

        this.obs.gerando_extrato = false
      }

    } catch {
      toast.error('Erro ao gerar extrato, tente novamente mais tarde.', {});
    }

    this.obs.gerando_extrato = false
  }

  @action
  async handleTransmissao(empresa: string, competencia: string, ano: string, retificar: boolean, regime: string, valor_adicional: any, esfera: number, processo: string, gerar_das: boolean): Promise<void> {
    this.obs.transmitindo = true

    let data: any = {}

    if (regime == "") {
      data = { empresa: empresa, competencia: competencia, ano: ano, retificar: retificar, valor_adicional: (valor_adicional == "." ? "0.0" : valor_adicional), gerarDas: gerar_das };
    } else {
      data = { empresa: empresa, competencia: competencia, ano: ano, retificar: retificar, regime: regime, valor_adicional: (valor_adicional == "." ? "0.0" : valor_adicional), gerarDas: gerar_das };
    }

    if (esfera != 0) {
      data.esferaAdm = esfera
      data.processo = processo
    }

    try {
      let resp = await api.post("/api/transmissao", data);

      if (resp.data.ok) {
        toast.success('Transmissão realizada com sucesso.', {})
      } else {
        toast.warning(resp.data.msg, {});
      }
    } catch (ex) {
      toast.error('Erro ao transmitir, tente novamente mais tarde.', {});
    }
    this.obs.transmitindo = false
  }

  @action
  async handleDas(paramns: any): Promise<void> {
    this.obs.loading = true

    let data = {}


    //data = { empresa: empresa, competencia: competencia, ano: ano};


    try {
      let resp = await api.post("/api/gerar-das", paramns);

      if (resp.data.ok) {
        toast.success('Transmissão realizada com sucesso.', {})
      } else {
        toast.warning(resp.data.msg, {});
      }
    } catch (ex) {
      toast.error('Erro ao transmitir, tente novamente mais tarde.', {});
    }
    this.obs.loading = false
  }


  async handleSendPagedBusca(empresa: IEmpresa, page: number): Promise<void> {
    this.obs.loading = true;
    this.obs.filtro = [];

    let req = { cnpj: empresa.cnpj, page: page, limit: 50 };
    try {
      let resp = await api.post(`/api/consulta-status-pgdas`, req);

      if (resp.data.items.length) {
        this.obs.req = resp.data.items;
        this.obs.pgdas_length = resp.data.count
      } else {
        this.obs.pgdas_length = 0
        this.obs.currentPage = 1
        this.obs.req = []
        toast.warning('Não há informações para serem exibidas.', {});
      }
    } catch (ex) {
      toast.error('Erro ao consultar, tente novamente mais tarde.', {});
    }
    this.obs.loading = false;
  }

  async consultaArquivo(uuid: string) {
    try {
      let req = { uuid: uuid };

      let resp = await api.post(`/api/consulta-arquivo-pgdas-tarefa`, req);

      return resp.data;
    } catch (ex) {
      toast.error('Erro ao consultar arquivo Pgdas, tente novamente mais tarde.', {});
    }
  }

  async downloadArquivo(uuid: string, nome: string, id: number) {
    try {
      let aux = nome.split(".");
      let l = aux.length;
      let format = l - 1;
      let req = { uuid: uuid, file_id: id };

      let resp = await api.post(`/api/download-one-pgdas`, req);
      if (resp.data.ok) {
        const linkSource = `data:application/${format};base64,${resp.data.base64}`;
        const downloadLink = document.createElement("a");
        const fileName = nome;

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      }
      else {
        toast.error('Erro ao realizar download arquivo Pgdas!', {});
      }

    } catch (ex) {
      toast.error('Erro ao realizar download arquivo Pgdas, tente novamente mais tarde.', {});
    }
  }

  async downloadArquivosAll(uuid: string, cnpj: string, arquivos: any) {
    try {
      let req = { uuid: uuid, arquivos: arquivos };

      let resp = await api.post(`/api/download-all-pgdas`, req);

      if (resp.data.ok) {
        const linkSource = `data:application/zip;base64,${resp.data.base64}`;
        const downloadLink = document.createElement("a");
        let fileName = `arquivos_transmissao_${cnpj}.zip`;

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      }
      else {
        toast.error(resp.data.error, {});
      }

    } catch (ex) {
      toast.error('Erro ao realizar download arquivos Pgdas, tente novamente mais tarde.', {});
    }
  }

  async consultaErro(uuid: string) {
    try {

      let req = { uuid: uuid };

      let resp = await api.post(`/api/consulta-erro-pgdas`, req);

      if (resp.data.length) {
        return resp.data;

      } else {
        return [" "]
      }
    } catch (ex) {
      toast.error('Erro ao consultar erro Pgdas, tente novamente mais tarde.', {});
    }
  }

  async downloadArquivos(uuid: string) {
    this.obs.loading_arquivos = true

    try {
      let resp = await api.get(`/api/download/xml/file/${uuid}`);

      if (resp.data.status) {
        const linkSource = `data:application/zip;base64,${resp.data.file}`;
        const downloadLink = document.createElement("a");
        const fileName = "xmls.zip";
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      } else {
        toast.error('Não foi possível realizar o download.', {});
      }
    } catch (ex) {
      toast.error('Erro Download Arquivo, tente novamente mais tarde.', {});
    }

    this.obs.loading_arquivos = false
  }

  async length_tarefas(contribuinte: string) {
    try {
      this.obs.tasks_length = 0;

      let resp = await api.get(`/api/download/xml/count/${contribuinte}`);

      this.obs.tasks_length = resp.data.total;
    } catch (ex) {
      toast.error("Erro ao contar total de solicitações, tente novamente mais tarde.", {});
    }
  }


  async graphs(cnpj: string, competencia: string, ano: string) {

    try {

      this.resetObs()

      this.obs.loading_bi = true

      let data = {
        cnpj: cnpj,
        month: parseInt(competencia),
        year: parseInt(ano)
      }

      let resp = await api.post(`/api/pgdas/graphs`, data);

      if (resp.data.ok) {

        this.obs.receita_bruta = resp.data.receita_bruta
        this.obs.total_de_impostos = resp.data.total_de_impostos
        this.obs.receita_e_limite_atual = resp.data.receita_e_limite_atual
        this.obs.limite_receita_simples = resp.data.limite_receita_simples
        this.obs.sublimite_receita = resp.data.sublimite_receita
        this.obs.segregacao_dos_tributos_periodo = resp.data.segregacao_dos_tributos_periodo
        this.obs.segregacao_dos_tributos = resp.data.segregacao_dos_tributos
        this.obs.segregacao_da_receita_bruta = resp.data.segregacao_da_receita_bruta
        this.obs.comparacao_entre_receitas = resp.data.comparacao_entre_receitas
        this.obs.projecao_linear_da_receita = resp.data.projecao_linear_da_receita
        this.obs.simples_nacional_periodo = resp.data.simples_nacional_periodo
        this.obs.carga_tributaria = resp.data.carga_tributaria
        this.obs.segregacao_de_cargas = resp.data.segregacao_de_cargas

        this.obs.simples_nacional = resp.data.simples_nacional
        this.obs.competencia = resp.data.competencia

        this.obs.total_receita_bruta = resp.data.total_receita_bruta
        this.obs.total_receita_bruta_12 = resp.data.total_receita_bruta_12
        this.obs.total_receita_bruta_anterior = resp.data.total_receita_bruta_anterior

        this.obs.loading_bi = false
        this.obs.isBI = true
        return

      } else {

        toast.warn(resp.data.msg, {})

      }

    } catch (ex) { }

    this.obs.loading_bi = false
    this.obs.isBI = false

  }

  resetObs() {

    this.obs.loading_bi = false
    this.obs.isBI = false

    this.obs.receita_bruta = [];
    this.obs.total_de_impostos = [];
    this.obs.receita_e_limite_atual = [];
    this.obs.segregacao_dos_tributos_periodo = [];
    this.obs.segregacao_dos_tributos = [];
    this.obs.segregacao_da_receita_bruta = [];
    this.obs.comparacao_entre_receitas = [];
    this.obs.projecao_linear_da_receita = [];
    this.obs.simples_nacional_periodo = [];
    this.obs.carga_tributaria = [];
    this.obs.segregacao_de_cargas = [];

    this.obs.simples_nacional = 0;
    this.obs.competencia = 0;
    this.obs.total_receita_bruta = 0;
    this.obs.total_receita_bruta_anterior = 0;
    this.obs.total_receita_bruta_12 = 0;
    this.obs.limite_receita_simples = 0;
    this.obs.sublimite_receita = 0;

  }

}

export const PgdasStore = new _PgdasStore();
